import React from "react";
import "./Dasturlash.css";
import {
  FaBootstrap,
  FaCss3,
  FaDatabase,
  FaHtml5,
  FaJava,
  FaNode,
  FaNodeJs,
  FaPhp,
  FaPython,
  FaReact,
  FaFilePdf,
  FaFileImage,
  FaTimes,
  FaVuejs,
  FaSwift,
  FaCalculator,
  FaBrain,
  FaRobot,
  FaLayerGroup,
  FaShareSquare,
  FaChartPie,
} from "react-icons/fa";
import { useState, useEffect } from "react";
import { QRCodeCanvas } from "qrcode.react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { toast } from "react-toastify";
import CONFIG from "../config";
import { encodeCertId } from "../utils/crypto";
import logo from "../Rasm/logo.png";
import certificate_frame from "../Rasm/certificate_frame_v2.png";
import { FaGem, FaStar, FaAward, FaChessKnight, FaCheckCircle } from "react-icons/fa";
import StatisticsModal from "./StatisticsModal";

export default function Dasturlash({ kurslar, userData }) {
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [showStatsModal, setShowStatsModal] = useState(false);
  const [bgLoaded, setBgLoaded] = useState(false);

  const downloadPDF = () => {
    const input = document.getElementById('course-certificate-node');
    if (!input) return;
    html2canvas(input, {
      scale: 2,
      useCORS: true,
      scrollX: 0,
      scrollY: 0,
      x: 0,
      y: 2,
      width: input.offsetWidth,
      height: input.offsetHeight - 4,
      backgroundColor: null
    }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('l', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save(`${selectedCourse.title}_Sertifikat.pdf`);
    });
  };

  const downloadJPG = () => {
    const input = document.getElementById('course-certificate-node');
    if (!input) return;
    html2canvas(input, {
      scale: 2,
      useCORS: true,
      scrollX: 0,
      scrollY: 0,
      x: 0,
      y: 2,
      width: input.offsetWidth,
      height: input.offsetHeight - 4,
      backgroundColor: null
    }).then((canvas) => {
      const link = document.createElement('a');
      link.download = `${selectedCourse.title}_Sertifikat.jpg`;
      link.href = canvas.toDataURL('image/jpeg', 1.0);
      link.click();
    });
  };

  const handleCourseClick = async (item) => {
    // If it's a real course, try to get/sync certificate from server
    if (item.id && !item.isTest) {
      const token = localStorage.getItem("loyiha_token");
      if (token) {
        try {
          const formData = new FormData();
          formData.append('kurs_id', item.id);

          const res = await fetch(`${CONFIG.API_BASE_URL}/kurs_sertifikat_yangilash.php`, {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}` },
            body: formData
          }).then(r => r.json());

          if (res.status === 'success') {
            setSelectedCourse({
              ...item,
              certificate_id: res.certificate_id,
              cert_date: res.date
            });
            return;
          } else {
            toast.error(res.message || "Sertifikat ma'lumotlarini yuklashda xatolik");
            return; // Don't open modal if error
          }
        } catch (err) {
          console.error("Cert sync error:", err);
          toast.error("Tarmoq xatoligi yuz berdi");
          return;
        }
      }
    }

    // Fallback only for icons that don't have an ID or are marked differently
    setSelectedCourse(item);
  };

  useEffect(() => {
    if (selectedCourse) {
      setBgLoaded(false);
      const img = new Image();
      img.src = certificate_frame;
      img.onload = () => {
        setBgLoaded(true);
      };
      img.onerror = () => {
        setBgLoaded(true);
      };
    }
  }, [selectedCourse]);

  // Map string names from DB to components
  const iconMap = {
    FaHtml5, FaCss3, FaNodeJs, FaBootstrap, FaReact, FaVuejs,
    FaPhp, FaSwift, FaPython, FaNode, FaJava, FaCalculator,
    FaBrain, FaRobot, FaDatabase, FaLayerGroup,
    FaShareSquare, // Fallback
    FaPaperPlane: FaShareSquare,
    FaAndroid: FaHtml5,
    FaApple: FaHtml5
  };

  // 1. Filter completed courses
  const completedList = Array.isArray(kurslar) ? kurslar.filter(k => {
    const total = k.total_lessons_calc || k.darslar_soni || 1;
    const completed = k.completed_lessons || 0;
    return k.sotib_olingan && completed >= total;
  }) : [];

  const icons = completedList.map(c => {
    const IconComp = iconMap[c.icon] || FaShareSquare;
    return {
      Icon: IconComp,
      title: c.nomi,
      id: c.id,
      ball: c.total_score || 0,
      mavzular: c.completed_lessons || 0
    };
  });

  // TEST: If empty, add fake HTML
  if (icons.length === 0) {
    icons.push({
      Icon: FaHtml5,
      title: "HTML",
      id: 9999,
      ball: 100,
      mavzular: 20,
      isTest: true // flag to key handlers
    });
  }

  // 3. Decide layout mode
  // If we have <= 12 icons, show grid. Else show scroll.
  const isScrollMode = icons.length > 12;

  return (
    <div className="foydalanuvchi-daraja-quti">
      <span>
        Dasturlash tili darajasi{" "}
        <div
          className="statistika-tugma"
          title="Statistika"
          onClick={() => setShowStatsModal(true)}
          style={{ display: 'inline-block', cursor: 'pointer' }}
        >
          <FaChartPie className="daraja-yuborish" />
        </div>
      </span>
      {icons.length > 0 ? (
        <div className={`foydalanuvchi-daraja-icon ${isScrollMode ? 'mode-scroll' : 'mode-grid'}`}>
          <div className="scroll-container">
            <div className="scroll-content">
              {icons.map((item, index) => (
                <div
                  key={`orig-${index}`}
                  className="icon-daraja-wrapper"
                  onClick={() => handleCourseClick(item)}
                >
                  <item.Icon className="icon-daraja" title={item.title} />
                </div>
              ))}
              {/* Duplicates for infinite scroll only if in scroll mode */}
              {isScrollMode && icons.map((item, index) => (
                <div
                  key={`dup-${index}`}
                  className="icon-daraja-wrapper"
                  onClick={() => handleCourseClick(item)}
                >
                  <item.Icon className="icon-daraja" title={item.title} />
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div style={{ padding: '1vw', textAlign: 'center', color: '#888', fontSize: '0.8vw' }}>
          Tugatilgan kurslar yo'q
        </div>
      )}

      {/* Course Detail Modal (Matches Mantiq logic) */}
      {selectedCourse && (
        <div className="certificate-modal-overlay"
          onClick={() => setSelectedCourse(null)}
          style={{
            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.8)', zIndex: 9999, display: 'flex',
            flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
          }}>

          <div style={{ marginBottom: '10px', width: '800px', display: 'flex', justifyContent: 'flex-end' }}>
            <button onClick={() => setSelectedCourse(null)}
              style={{ background: 'none', border: 'none', color: '#fff', fontSize: '24px', cursor: 'pointer' }}>
              <FaTimes />
            </button>
          </div>

          <div id="course-certificate-node" className="certificate-container" onClick={(e) => e.stopPropagation()} style={{
            position: 'relative',
            width: '800px',
            height: '565px',
            padding: '40px',
            backgroundColor: '#fff',
            backgroundImage: bgLoaded ? `url(${certificate_frame})` : 'none',
            backgroundPosition: 'center',
            backgroundSize: '100% 100%',
            backgroundRepeat: 'no-repeat',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            color: '#333',
            boxShadow: '0 0 50px rgba(0,0,0,0.5)',
            fontFamily: "'Roboto Mono', monospace",
            overflow: 'hidden'
          }}>
            {!bgLoaded && (
              <div className="cert-loading-overlay">
                <div className="cert-spinner"></div>
                <span>Sertifikat tayyorlanmoqda...</span>
              </div>
            )}
            {/* Watermark */}
            <div style={{
              position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
              opacity: 0.05, width: '500px', height: '500px',
              backgroundImage: `url(${logo})`, backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center', backgroundSize: 'contain',
              zIndex: 0, pointerEvents: 'none'
            }}></div>

            <div style={{ zIndex: 1, textAlign: 'center', width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', paddingBottom: '20px' }}>
              <div>
                <h1 style={{ fontSize: '42px', color: 'rgb(141, 71, 21)', margin: '80px 0 0 0', textTransform: 'uppercase', letterSpacing: '4px', fontFamily: "'Playfair Display', serif", fontWeight: '900' }}>
                  {selectedCourse.title.toUpperCase()} DARAJASI
                </h1>

                <p style={{ fontSize: '18px', margin: '10px 0' }}>Muvaffaqiyat guvohnomasi beriladi:</p>
                <h2 style={{ fontSize: '22px', margin: '10px 0', color: '#000', borderBottom: '1px solid rgb(141, 71, 21)', display: 'inline-block', paddingBottom: '5px', fontWeight: '700' }}>
                  {userData?.fio || "Foydalanuvchi"}
                </h2>

                <p style={{ fontSize: '16px', margin: '15px auto', maxWidth: '85%', lineHeight: '1.7', textAlign: 'center' }}>
                  <b>Suvoriy.com</b> platformasining <selectedCourse.Icon style={{ color: 'rgb(141, 71, 21)', fontSize: '1.3rem', verticalAlign: 'middle', margin: '0 5px' }} /> <b>“{selectedCourse.title}”</b> bosqichi doirasida faol ishtirok etib, bilim va mahoratini muvaffaqiyatli namoyon etgani uchun.
                </p>
              </div>

              <div style={{ display: 'flex', justifyContent: 'center', gap: '100px', margin: '30px 0' }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '28px', color: 'rgb(141, 71, 21)', marginBottom: '-8px' }}><FaCheckCircle /></div>
                  <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'rgb(141, 71, 21)' }}>{selectedCourse.mavzular || '0'}</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '28px', color: 'rgb(141, 71, 21)', marginBottom: '-8px' }}><FaGem /></div>
                  <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'rgb(141, 71, 21)' }}>{selectedCourse.ball || '0'}</div>
                </div>
              </div>

              <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'end', width: '100%', paddingLeft: '50px', marginBottom: '160px', marginTop: '-120px' }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ background: '#fff', padding: '5px', display: 'inline-block', border: '1px solid #ddd' }}>
                    <QRCodeCanvas
                      value={`https://suvoriy.com/verify-id/AL${encodeCertId(selectedCourse.certificate_id || selectedCourse.id || 0)}`}
                      size={80}
                    />
                  </div>
                  <div style={{ fontSize: '10px', marginTop: '4px', color: '#666' }}>
                    <span style={{ fontWeight: 'bold', display: 'block', marginBottom: '2px', color: '#000' }}>
                      ID: AL{String(selectedCourse.certificate_id || selectedCourse.id || 0).padStart(6, '0')}
                    </span>
                    {selectedCourse.cert_date || new Date().toLocaleDateString()}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="cert-actions" style={{ marginTop: '20px', display: 'flex', gap: '20px' }} onClick={(e) => e.stopPropagation()}>
            <button className="cert-btn save-pdf" onClick={downloadPDF}>
              <FaFilePdf /> PDF Saqlash
            </button>
            <button className="cert-btn save-jpg" onClick={downloadJPG}>
              <FaFileImage /> JPG Saqlash
            </button>
          </div>
        </div>
      )}

      <StatisticsModal
        isOpen={showStatsModal}
        onClose={() => setShowStatsModal(false)}
        userData={userData}
      />
    </div>
  );
}
